// src/components/PortfolioCard.jsx
// Card de item do portfólio, usado na página Portfólio e na prévia da Home.
import ViewfinderFrame from "./ViewfinderFrame";
import "./PortfolioCard.css";

function Midia({ item }) {
  const { midia, titulo } = item;

  if (midia.kind === "youtube") {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${midia.id}`}
        title={titulo}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    );
  }

  if (midia.kind === "video") {
    return <video src={midia.src} autoPlay muted loop playsInline preload="metadata" />;
  }

  return <img src={midia.src} alt={titulo} loading="lazy" />;
}

function PortfolioCard({ item }) {
  const isEmbed = item.midia.kind === "youtube";
  return (
    <article className="portfolio-card">
      <ViewfinderFrame
        tag={item.tag}
        className={`portfolio-media ${isEmbed ? "portfolio-media--embed" : ""}`}
      >
        <Midia item={item} />
      </ViewfinderFrame>
      <p className="portfolio-caption">
        {item.titulo} · {item.local}
      </p>
    </article>
  );
}

export default PortfolioCard;
